import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const gallerySerene: Collection = {
  id: 'sp-gallery-serene',
  brandId: 'sp',
  brandName: 'S|P Collection',
  icon: 'sp-collection.png',
  title: 'Gallery - Serene',
  subTitle: 'Heerlijke geuren',
  banner: 'gallery-serene/gallery-serene-banner.jpg',
  items: [
    {
      id: 'sp-gallery-serene-1',
      collectionImages: [
        {
          image: 'gallery-serene/Gallery_white.jpg',
          width: CollectionBannerWidth['66%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'gallery-serene/Gallerywhite_Cave_2.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'sp-gallery-serene-2',
      collectionImages: [
        {
          image: 'gallery-serene/Gallery_Studio Urban_Cosmo_Zone_Coco.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'gallery-serene/Gallery_Gold.jpg',
          width: CollectionBannerWidth['66%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'sp-gallery-serene-4',
      collectionImages: [
        {
          image: 'gallery-serene/Serene_2.jpg',
          width: CollectionBannerWidth['100%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'sp-gallery-serene-3',
      collectionImages: [
        {
          image: 'gallery-serene/Gallery_Giftbox_3.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'gallery-serene/Gallery_Giftbox.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    '03e72ca0-8de2-46a4-9572-8b5ea05c84db',
    '150d4e8f-b1a0-4fba-bf58-bb441df130af',
    '3116d713-efc0-4895-b824-3b5fb371dfe8',
    '59fbb586-6f0d-4447-9f6e-e4ab60c88b26',
    '0f4038fe-6d21-4489-b746-ae8d3e4e41b2',
    '64504793-ae95-42c4-b8ce-163867517b21',
    'd345f895-f435-46ee-97d8-a27ba460fcc6',
    '842cb1fb-4e28-4d7e-958d-b96104341d47',
    'f487859a-6dbe-486b-bd9e-e1d3491d4e0a',
    '59e7c26f-a49b-4e94-a97f-063b1eadf4aa',
    '7c78264a-f0c0-41e8-9aa1-49f8eb234771',
    'b5e30719-c3c5-4cff-a5be-b8399723a2a2',
    'f532ae4f-d9ac-4a0f-8026-03ef5ba73670',
    '1e7fac73-e635-44fb-b9cc-0c36b7667c83',
    'f543c7cd-eaec-4233-a04a-11f3ff436e1a',
    'ef3fc0c8-4c33-407c-b15c-ac9c3e2ab2a0',
    '86a02427-d5bf-4a60-bca0-d0eb8c0b5724',
    'b2187153-2e2f-40ad-be68-a0dba7ef89f7',
    'b6028302-2654-4cb7-a001-2ce7ef728d97',
    '2405b651-2c97-4f53-97d9-7bfe9d0f9456',
    '02113b82-38b1-4198-b773-0e10494c3939',
    '15c0f85e-3864-48ed-b779-2834ac39dfd4',
    'e83b857d-4420-44c9-b720-5bed333eeaae',
    '8aa0ba98-9c24-4e0a-8a9b-d04adc2dc5b5',
    '65975e33-54af-4bf4-ac69-219ec1184cf7',
    'e2fb3da0-093f-4de1-a9a5-34b8c556d688',
    'ff45af9e-923f-41e4-9bda-dcbb0394eae9',
    '1b9b3aa2-c873-46c7-8a3d-173654769ad5',
    'b28958bb-987d-41b6-b2de-575f573b2a52',
    '13f16b6b-940d-4518-8449-0c04abc7346b',
    '40421345-0be7-4104-917c-f35b51d44dc3',
    'e4242f88-849e-4b2e-a3ce-cba3d386571b',
    'd6f386fd-2b6c-4963-85ca-531d37026b7e',
    'd6221dfa-13b5-4640-a5cc-bcf4e2a6eecd',
    '48f7d209-b093-49d8-a6ff-bedbd36d568c',
    'b7f89fd3-8b20-49da-9712-d7ea354b0aea',
    '6fdcaa90-0b77-4aab-b40c-1c7a1c3a979c',
    'b031f57a-4415-4529-ad75-03d38a3b3c93',
    'abae0483-1c8a-4d44-8b6f-c98c3074c5c0',
    'cb0a133e-d4aa-478a-a795-e4273426c891',
    '38199422-b2ba-46f1-8ce0-78aaddbd305f',
    '4b997dc2-482a-4afa-bff0-9190a0654c74'
  ]
};
